export default __webpack_public_path__ + "static/media/swipe.f4dc3a9e.svg";